import { useGetMeMutation } from '@services';
import { eventEmitter } from '@utils';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useDefaultBottomBar = (setShowMenu: React.Dispatch<React.SetStateAction<boolean>>) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [getMe, { data: meData }] = useGetMeMutation();
    const [unseenNotificationCount, setUnseenNotificationCount] = useState(0);

    useEffect(() => {
        getMe();
    }, [getMe]);

    useEffect(() => {
        if (meData && meData?.notifications.length > 0) {
            setUnseenNotificationCount(meData.notifications.filter(notification => !notification.seen).length);
        } else {
            setUnseenNotificationCount(0);
        }
    }, [meData]);

    // Refresh the unread badge whenever a notification is marked as seen
    // (single or bulk). The NotificationsPage emits this after its mutations.
    useEffect(() => {
        const handler = () => {
            getMe();
        };
        eventEmitter.on('notifications:updated', handler);
        return () => {
            eventEmitter.off('notifications:updated', handler);
        };
    }, [getMe]);

    const handleNavigateToHome = () => {
        navigate('/home');
        setShowMenu(false);
    };

    const handleNavigateToNotifications = () => {
        navigate('/notifications');
        setShowMenu(false);
    };

    useEffect(() => {
        setShowMenu(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    return { handleNavigateToHome, handleNavigateToNotifications, unseenNotificationCount };
};
